// extracted by mini-css-extract-plugin
export default {"column":"column___ha9Rv"};